export const LANGUAGES = [
  { code: 'it', name: 'Italiano' },
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'de', name: 'Deutsch' },
];

export const translations = {
  it: {
    meta: {
      homeTitle: 'Gustavo 28 — Eventi, Team Building & Catering a Milano',
      homeDesc: 'Cooking, wine & beer team building, eventi aziendali e catering: nella nostra location di 160 mq a Milano, nei vostri uffici o dove preferite. Un unico partner, tutti i servizi.',
      serviziTitle: 'Servizi — Cooking, Wine, Catering & Eventi | Gustavo 28 Milano',
      serviziDesc: 'Cooking team building, wine & cocktail experience, eventi aziendali, promozione di brand e catering: scopri l\u2019offerta di Gustavo 28 a Milano e presso la tua sede.',
      tbTitle: 'Team Building a Milano — Cooking, Wine & Cocktail | Gustavo 28',
      tbDesc: 'Pacchetti di team building modulabili: cooking challenge, wine & cocktail lab, beer experience e food & art. Nella nostra location o presso la tua azienda, anche in inglese, spagnolo, francese, giapponese e cinese.',
      locationTitle: 'Location per Press Day e Temporary Showroom a Milano | Gustavo 28',
      locationDesc: 'Location in affitto esclusivo a Milano per press day, presentazioni di prodotto, temporary showroom per il Salone del Mobile e la Fashion Week, cene private con chef ed eventi aziendali. Con o senza allestimento.',
      locationKeys: 'location per press day Milano, temporary showroom Salone del Mobile, affitto location esclusiva Milano, location Fashion Week Milano, cene private con chef Milano, affitto spazio eventi Milano',
      xmasTitle: 'Business Christmas Party a Milano — Location e menu dedicati | Gustavo 28',
      xmasDesc: 'Organizza il Christmas Party aziendale a Milano: location allestita con albero e decorazioni, menu dedicati dei nostri chef, cocktail e cooking challenge natalizia. Contattaci.',
      contattiTitle: 'Contatti — Richiedi un Preventivo | Gustavo 28 Milano',
      contattiDesc: 'Contatta Gustavo 28 per organizzare il tuo evento o team building a Milano o presso la tua sede: compila il form e ricevi una proposta su misura entro 24 ore.',
    },
    nav: { home: 'Home', servizi: 'Servizi', tb: 'Team Building', xmas: 'Christmas Party', location: 'La Location', contatti: 'Contatti', cta: 'Richiedi un preventivo' },
    home: {
      kicker: 'Milano · Casa Maggioni, 1909',
      heroLines: ['Un unico partner,', 'una location,', 'tutti i servizi.'],
      heroSub: 'Cooking, wine & beer team building, eventi aziendali, catering e promozione di brand: nella nostra location, nei vostri uffici o dove preferite. Dall\u2019idea alla realizzazione, ci occupiamo di tutto noi.',
      ctaPrimary: 'Richiedi un preventivo',
      ctaSecondary: 'Scopri la location',
      scroll: 'Scorri',
      marquee: ['Cooking', 'Wine', 'Cocktail', 'Food & Art', 'Catering', 'Team Building', 'Eventi Aziendali', 'Sostenibilità'],
      chaptersKicker: 'Gustavo 28 in breve',
      chapters: [
        { title: 'Chi siamo', text: 'Gustavo 28 è un\u2019azienda specializzata nella creazione di eventi esclusivi, attività di team building ed eventi di promozione per i brand. La nostra mission è soddisfare le esigenze dei clienti con servizi efficienti, all\u2019avanguardia e cuciti su misura.' },
        { title: 'Ovunque voi siate', text: 'Realizziamo i nostri eventi nella nostra location di Via Gustavo Modena 28, ma anche presso i vostri uffici o in qualsiasi spazio scelto da voi. Stesso team, stessa qualità, stessa cura: portiamo tutto noi.' },
        { title: 'La location', text: '160 mq su due piani in un palazzo liberty del 1909, anche in affitto esclusivo: cene private con chef, press day e presentazioni di prodotto, temporary showroom per la Fashion Week e il Salone del Mobile, eventi aziendali istituzionali. Con o senza allestimento interno: la cucina professionale è mobile e si può rimuovere.', cta: 'Visita la location' },
      ],
      servicesKicker: 'La nostra offerta',
      servicesTitle: 'Esperienze su misura',
      services: [
        { title: 'Cooking Team Building', desc: 'Sfide ai fornelli e cooking class con chef professionisti, nella nostra cucina industriale o presso la vostra sede.' },
        { title: 'Wine & Cocktail Experience', desc: 'Degustazioni guidate e mixology, con tutor dedicati e cantine selezionate.' },
        { title: 'Eventi Aziendali & Promozione', desc: 'Meeting, cene di gala, lanci di prodotto e brand activation, dall\u2019idea alla realizzazione.' },
        { title: 'Catering & Banqueting', desc: 'Catering di qualità nella nostra location o dove preferisci, con materie prime selezionate.' },
      ],
      servicesCta: 'Tutti i servizi',
      partnersKicker: 'Partner & fornitori',
      galleryKicker: 'La gallery',
      galleryTitle: 'I nostri eventi',
      partners: ['Gentile since 1950', 'Midora Atelier Gastronomico', 'F.lli Abrigo · Cascina Langairolo', 'Casa Bugatti', 'Alma Design'],
      bannerTitle: 'Pronto a creare il tuo evento?',
      bannerText: 'Raccontaci la tua idea: ti rispondiamo entro 24 ore con una proposta su misura.',
      bannerCta: 'Parliamone',
    },
    servizi: {
      kicker: 'I servizi',
      title: 'Un\u2019offerta ampia e innovativa',
      intro: 'Combiniamo cucina, cocktail, wine, arte, design e formazione in format sostenibili e a basso impatto. Nella nostra location di Milano, nei vostri uffici o nella venue che preferite: il nostro team vi raggiunge ovunque.',
      items: [
        { title: 'Affitto Location in Esclusiva', desc: 'Cene private con chef, press day e presentazioni di prodotto, temporary showroom per la Fashion Week e il Salone del Mobile, eventi istituzionali: 160 mq tutti per te, con o senza allestimento — la cucina è mobile e rimovibile.' },
        { title: 'Cooking Team Building', desc: 'Sfide ai fornelli, cooking class e format creativi guidati da chef professionisti, nella nostra cucina industriale in acciaio o attrezzando la vostra sede.' },
        { title: 'Wine & Beer Experience', desc: 'Degustazioni guidate e percorsi nel mondo del vino e della birra artigianale, con tutor dedicati, anche presso i vostri uffici.' },
        { title: 'Cocktail & Food Art', desc: 'Mixology, food design e arte si incontrano in esperienze immersive e spettacolari, nella nostra location o da voi.' },
        { title: 'Eventi Aziendali', desc: 'Meeting, convention, cene di gala e momenti di celebrazione, gestiti dall\u2019idea alla realizzazione, in location nostra o vostra.' },
        { title: 'Eventi di Promozione', desc: 'Lanci di prodotto, brand activation e temporary event per raccontare il tuo marchio, ovunque serva.' },
        { title: 'Catering & Banqueting', desc: 'Catering di qualità, nella nostra location o dove preferisci, con materie prime selezionate.' },
      ],
      cardCta: 'Richiedi questo servizio',
      bannerTitle: 'Non trovi quello che cerchi?',
      bannerText: 'Ogni evento è cucito su misura: raccontaci la tua idea e la costruiamo insieme.',
      bannerCta: 'Contattaci',
    },
    tb: {
      kicker: 'Team Building',
      title: 'Pacchetti modulabili, esperienze indimenticabili',
      intro: 'Presso la nostra location di Via Gustavo Modena 28, nei vostri uffici o in una venue scelta da voi: ogni pacchetto è componibile sulle esigenze del tuo team.',
      formatsKicker: 'I format',
      formats: [
        { title: 'Cooking Challenge', desc: 'Brigate ai fornelli, mistery box e giudizio finale: la metafora perfetta del lavoro di squadra.' },
        { title: 'Wine & Cocktail Lab', desc: 'Costruisci il drink perfetto con i nostri bartender e sommelier.' },
        { title: 'Beer Experience', desc: 'Alla scoperta della birra artigianale: stili, abbinamenti e degustazione guidata.' },
        { title: 'Food & Art', desc: 'Cucina e creatività si incontrano: food design, plating e arte.' },
      ],
      langsKicker: 'Multilingua',
      langsTitle: 'Attività in lingua straniera',
      cookingLabel: 'Cooking team building',
      cookingLangs: 'Inglese · Spagnolo · Francese · Giapponese · Cinese',
      wineLabel: 'Cocktail & wine team building',
      wineLangs: 'Inglese · Spagnolo',
      langsNote: 'Previa disponibilità degli chef e dei tutor dedicati.',
      bannerTitle: 'Costruiamo il tuo team building',
      bannerText: 'Dicci obiettivi, numero di partecipanti e budget: al resto pensiamo noi.',
      bannerCta: 'Richiedi una proposta',
    },
    location: {
      kicker: 'La Location',
      title: 'Elegante, versatile, tua',
      intro: 'Via Gustavo Modena 28, Milano. Un palazzo signorile in zona Indipendenza/Risorgimento che si estende per 160 mq su due piani.',
      floorsKicker: 'Due piani, infinite possibilità',
      floors: [
        { title: 'Piano 0 — La cucina', text: 'Due vetrine su strada (oscurabili) e una cucina professionale dotata di banconi, forni, piastre a induzione e portata kW adeguata.' },
        { title: 'Piano -1 — Lo spazio modulabile', text: 'Volutamente vuoto per essere personalizzato secondo le esigenze del cliente, con bancone su ruote e cantina vino in ferro.' },
      ],
      featuresKicker: 'Perché sceglierla',
      features: [
        { title: 'Elegante e versatile', desc: 'Un palazzo signorile liberty del 1909: mattoni a vista, luci calde e dettagli raffinati.' },
        { title: 'Dotazioni tecniche incluse', desc: 'Cucina professionale completa, attrezzature e portata elettrica adeguata ad ogni format.' },
        { title: 'Flessibilità di layout', desc: 'Spazi modulabili e personalizzabili per ogni tipo di evento, dal meeting alla cena di gala.' },
        { title: 'Anche in affitto', desc: 'La location è disponibile per il tuo evento, con o senza i nostri servizi — e con o senza allestimento: la cucina è mobile.' },
      ],
      rentKicker: 'Affitto in esclusiva',
      rentTitle: 'Uno spazio che si adatta al tuo evento',
      rentCases: [
        { title: 'Cene private con chef', desc: 'Una cena esclusiva con chef dedicato, in uno spazio riservato tutto per voi.' },
        { title: 'Press day & presentazioni di prodotto', desc: 'Due vetrine su strada e una scenografia elegante per stampa e lanci.' },
        { title: 'Temporary showroom', desc: 'La cornice ideale per la Fashion Week e il Salone del Mobile, nel cuore di Milano.' },
        { title: 'Eventi aziendali istituzionali', desc: 'Meeting, celebrazioni e momenti ufficiali in un palazzo liberty del 1909.' },
      ],
      rentNote: 'Con o senza allestimento interno: affitti lo spazio vuoto o allestito da noi. La cucina professionale è mobile e può essere rimossa quando non serve, per lasciare tutta la scena al tuo evento.',
      reachKicker: 'Come raggiungerci',
      reachTitle: 'Zona Indipendenza / Risorgimento',
      reachText: 'MM Dateo (linea blu, 300 mt) o Tricolore. Parcheggio consigliato: Via Gustavo Modena 10, Milano.',
      address: 'Via Gustavo Modena 28, 20129 Milano',
      bannerTitle: 'Vieni a vedere la location',
      bannerText: 'Organizza una visita: il modo migliore per immaginare il tuo evento è vivere lo spazio.',
      bannerCta: 'Prenota una visita',
    },
    xmas: {
      kicker: 'Natale 2026 · Milano',
      title: 'Organizza con noi il tuo Business Christmas Party',
      intro: 'La nostra location si veste a festa: albero raffinato, luci calde e pacchi regalo. Cena di gala, cocktail party o cooking challenge natalizia — e se cerchi solo lo spazio, lo affittiamo già allestito per le feste.',
      formatsKicker: 'I format natalizi',
      formats: [
        { title: 'Cena di Natale aziendale', desc: 'Menu dedicato dei nostri chef, servito nella location vestita per le feste.' },
        { title: 'Cocktail & Wine Party', desc: 'Brindisi, cocktail bar e degustazioni guidate per celebrare l\u2019anno insieme.' },
        { title: 'Cooking Challenge natalizia', desc: 'La brigata ai fornelli tra ricette delle feste e sfide a tema.' },
        { title: 'Location allestita in affitto', desc: 'Albero, luci e decorazioni già pronti: tu porti gli ospiti, al resto pensiamo noi.' },
      ],
      menuTitle: 'Servizi e menu dedicati',
      menuText: 'Menu natalizi studiati dai nostri chef, materie prime selezionate e staff completo: raccontaci numero di ospiti e budget, ti inviamo la proposta entro 24 ore.',
      menuCta: 'Scopri servizi e menu',
      bannerTitle: 'Prenota la data del tuo Christmas Party',
      bannerText: 'Le date di dicembre si riempiono in fretta: contattaci e blocchiamo insieme la serata.',
      bannerCta: 'Contattaci',
    },
    contatti: {
      kicker: 'Contatti',
      title: 'Raccontaci il tuo evento',
      intro: 'Compila il form: ti ricontattiamo entro 24 ore con una proposta su misura.',
      infoTitle: 'Dove siamo e come contattarci',
      phoneLabel: 'Telefono',
      emailLabel: 'Email',
      addressLabel: 'Indirizzo',
      address: 'Via Gustavo Modena 28, 20129 Milano',
      form: {
        name: 'Nome e cognome',
        email: 'Email',
        phone: 'Telefono (opzionale)',
        eventType: 'Tipo di evento',
        types: ['Cooking Team Building', 'Wine / Cocktail Experience', 'Evento aziendale', 'Evento di promozione', 'Catering', 'Affitto location', 'Altro'],
        guests: 'Numero di ospiti (opzionale)',
        message: 'Raccontaci il tuo evento',
        submit: 'Invia la richiesta',
        sending: 'Invio in corso…',
        success: 'Richiesta inviata! Ti ricontatteremo entro 24 ore.',
        error: 'Qualcosa è andato storto. Riprova o scrivici a eventi@gustavo28.it',
      },
    },
    footer: {
      tagline: 'Un unico partner, una location, tutti i servizi.',
      exploreTitle: 'Esplora',
      contactTitle: 'Contatti',
      partnersTitle: 'Partner',
      rights: '© 2026 Gustavo 28 — Milano',
    },
  },
  en: {
    meta: {
      homeTitle: 'Gustavo 28 — Events, Team Building & Catering in Milan',
      homeDesc: 'Cooking, wine & beer team building, corporate events and catering: at our 160 sqm venue in Milan, at your offices or wherever you prefer. One partner, every service.',
      serviziTitle: 'Services — Cooking, Wine, Catering & Events | Gustavo 28 Milan',
      serviziDesc: 'Cooking team building, wine & cocktail experiences, corporate events, brand promotion and catering: discover the Gustavo 28 offer in Milan or at your premises.',
      tbTitle: 'Team Building in Milan — Cooking, Wine & Cocktail | Gustavo 28',
      tbDesc: 'Modular team building packages: cooking challenges, wine & cocktail labs, beer experiences and food & art. At our venue or at your company, also in English, Spanish, French, Japanese and Chinese.',
      locationTitle: 'Press Day Venue & Temporary Showroom in Milan | Gustavo 28',
      locationDesc: 'Venue for exclusive hire in Milan: press days, product presentations, temporary showrooms for Salone del Mobile and Fashion Week, private dinners with chef and corporate events. With or without setup.',
      locationKeys: 'press day venue Milan, temporary showroom Salone del Mobile, exclusive venue hire Milan, Fashion Week venue Milan, private dinner with chef Milan, event space hire Milan',
      xmasTitle: 'Business Christmas Party in Milan — Venue & dedicated menus | Gustavo 28',
      xmasDesc: 'Organize your corporate Christmas Party in Milan: venue styled with tree and decorations, dedicated menus by our chefs, cocktails and Christmas cooking challenge. Contact us.',
      contattiTitle: 'Contact — Request a Quote | Gustavo 28 Milan',
      contattiDesc: 'Contact Gustavo 28 to organize your event or team building in Milan or at your premises: fill in the form and receive a tailor-made proposal within 24 hours.',
    },
    nav: { home: 'Home', servizi: 'Services', tb: 'Team Building', xmas: 'Christmas Party', location: 'The Venue', contatti: 'Contact', cta: 'Request a quote' },
    home: {
      kicker: 'Milan · Casa Maggioni, 1909',
      heroLines: ['One partner,', 'one location,', 'every service.'],
      heroSub: 'Cooking, wine & beer team building, corporate events, catering and brand promotion: at our venue, at your offices or wherever you prefer. From the first idea to the final toast, we take care of everything.',
      ctaPrimary: 'Request a quote',
      ctaSecondary: 'Discover the venue',
      scroll: 'Scroll',
      marquee: ['Cooking', 'Wine', 'Cocktail', 'Food & Art', 'Catering', 'Team Building', 'Corporate Events', 'Sustainability'],
      chaptersKicker: 'Gustavo 28 in short',
      chapters: [
        { title: 'Who we are', text: 'Gustavo 28 specializes in exclusive events, team building activities and brand promotion. Our mission is to meet our clients\u2019 needs with efficient, cutting-edge, tailor-made services.' },
        { title: 'Wherever you are', text: 'We run our events at our venue in Via Gustavo Modena 28, but also at your offices or in any space you choose. Same team, same quality, same care: we bring everything.' },
        { title: 'The venue', text: '160 sqm over two floors in an elegant 1909 Art Nouveau building, also available for exclusive hire: private dinners with chef, press days and product presentations, temporary showrooms for Fashion Week and Salone del Mobile, institutional corporate events. With or without interior setup: the professional kitchen is mobile and can be removed.', cta: 'Visit the venue' },
      ],
      servicesKicker: 'What we do',
      servicesTitle: 'Tailor-made experiences',
      services: [
        { title: 'Cooking Team Building', desc: 'Cooking challenges and classes with professional chefs, in our industrial kitchen or at your premises.' },
        { title: 'Wine & Cocktail Experience', desc: 'Guided tastings and mixology, with dedicated tutors and selected wineries.' },
        { title: 'Corporate & Promotion Events', desc: 'Meetings, gala dinners, product launches and brand activations, from idea to execution.' },
        { title: 'Catering & Banqueting', desc: 'Quality catering at our venue or wherever you prefer, with selected ingredients.' },
      ],
      servicesCta: 'All services',
      partnersKicker: 'Partners & suppliers',
      galleryKicker: 'The gallery',
      galleryTitle: 'Our events',
      partners: ['Gentile since 1950', 'Midora Atelier Gastronomico', 'F.lli Abrigo · Cascina Langairolo', 'Casa Bugatti', 'Alma Design'],
      bannerTitle: 'Ready to create your event?',
      bannerText: 'Tell us your idea: we will reply within 24 hours with a tailor-made proposal.',
      bannerCta: 'Let\u2019s talk',
    },
    servizi: {
      kicker: 'Our services',
      title: 'A broad, innovative offer',
      intro: 'We combine cuisine, cocktails, wine, art, design and training into sustainable, low-impact formats. At our venue in Milan, at your offices or at the venue you prefer: our team reaches you anywhere.',
      items: [
        { title: 'Exclusive Venue Hire', desc: 'Private dinners with chef, press days and product presentations, temporary showrooms for Fashion Week and Salone del Mobile, institutional events: 160 sqm all yours, with or without setup — the kitchen is mobile and removable.' },
        { title: 'Cooking Team Building', desc: 'Cooking challenges, classes and creative formats led by professional chefs, in our industrial steel kitchen or by equipping your premises.' },
        { title: 'Wine & Beer Experience', desc: 'Guided tastings and journeys through wine and craft beer, with dedicated tutors, also at your offices.' },
        { title: 'Cocktail & Food Art', desc: 'Mixology, food design and art meet in immersive, spectacular experiences, at our venue or yours.' },
        { title: 'Corporate Events', desc: 'Meetings, conventions, gala dinners and celebrations, managed from idea to execution, at our venue or yours.' },
        { title: 'Promotion Events', desc: 'Product launches, brand activations and pop-up events to tell your brand story, wherever needed.' },
        { title: 'Catering & Banqueting', desc: 'Quality catering, at our venue or wherever you prefer, with selected ingredients.' },
      ],
      cardCta: 'Request this service',
      bannerTitle: 'Can\u2019t find what you need?',
      bannerText: 'Every event is tailor-made: tell us your idea and we will build it together.',
      bannerCta: 'Get in touch',
    },
    tb: {
      kicker: 'Team Building',
      title: 'Modular packages, unforgettable experiences',
      intro: 'At our venue in Via Gustavo Modena 28, at your offices or at a venue of your choice: every package can be tailored to your team\u2019s needs.',
      formatsKicker: 'The formats',
      formats: [
        { title: 'Cooking Challenge', desc: 'Teams at the stove, mystery boxes and a final verdict: the perfect metaphor for teamwork.' },
        { title: 'Wine & Cocktail Lab', desc: 'Build the perfect drink with our bartenders and sommeliers.' },
        { title: 'Beer Experience', desc: 'Discover craft beer: styles, pairings and guided tasting.' },
        { title: 'Food & Art', desc: 'Where cuisine meets creativity: food design, plating and art.' },
      ],
      langsKicker: 'Multilingual',
      langsTitle: 'Activities in foreign languages',
      cookingLabel: 'Cooking team building',
      cookingLangs: 'English · Spanish · French · Japanese · Chinese',
      wineLabel: 'Cocktail & wine team building',
      wineLangs: 'English · Spanish',
      langsNote: 'Subject to availability of our dedicated chefs and tutors.',
      bannerTitle: 'Let\u2019s build your team building',
      bannerText: 'Tell us your goals, group size and budget: we\u2019ll take care of the rest.',
      bannerCta: 'Request a proposal',
    },
    location: {
      kicker: 'The Venue',
      title: 'Elegant, versatile, yours',
      intro: 'Via Gustavo Modena 28, Milan. An elegant building in the Indipendenza/Risorgimento district, 160 sqm over two floors.',
      floorsKicker: 'Two floors, endless possibilities',
      floors: [
        { title: 'Ground floor — The kitchen', text: 'Two shop windows (with blackout option) and a professional kitchen with workstations, ovens, induction hobs and adequate power supply.' },
        { title: 'Lower floor — The flexible space', text: 'Deliberately empty to be customized to your needs, with a mobile bar counter and an iron wine cellar.' },
      ],
      featuresKicker: 'Why choose it',
      features: [
        { title: 'Elegant & versatile', desc: 'An elegant 1909 Art Nouveau building: exposed bricks, warm lighting and refined details.' },
        { title: 'Technical equipment included', desc: 'A fully equipped professional kitchen and adequate power supply for every format.' },
        { title: 'Flexible layout', desc: 'Modular, customizable spaces for any kind of event, from meetings to gala dinners.' },
        { title: 'Available for hire', desc: 'The venue can be rented for your event, with or without our services — and with or without setup: the kitchen is mobile.' },
      ],
      rentKicker: 'Exclusive hire',
      rentTitle: 'A space that adapts to your event',
      rentCases: [
        { title: 'Private dinners with chef', desc: 'An exclusive dinner with a dedicated chef, in a space reserved just for you.' },
        { title: 'Press days & product presentations', desc: 'Two shop windows on the street and an elegant backdrop for press and launches.' },
        { title: 'Temporary showroom', desc: 'The perfect setting for Fashion Week and Salone del Mobile, in the heart of Milan.' },
        { title: 'Institutional corporate events', desc: 'Meetings, celebrations and official occasions in a 1909 Art Nouveau building.' },
      ],
      rentNote: 'With or without interior setup: hire the space empty or styled by us. The professional kitchen is mobile and can be removed when you don\u2019t need it, leaving centre stage to your event.',
      reachKicker: 'Getting here',
      reachTitle: 'Indipendenza / Risorgimento district',
      reachText: 'MM Dateo (blue line, 300 m) or Tricolore. Recommended parking: Via Gustavo Modena 10, Milan.',
      address: 'Via Gustavo Modena 28, 20129 Milan',
      bannerTitle: 'Come and see the venue',
      bannerText: 'Book a visit: the best way to imagine your event is to experience the space.',
      bannerCta: 'Book a visit',
    },
    xmas: {
      kicker: 'Christmas 2026 · Milan',
      title: 'Let us organize your Business Christmas Party',
      intro: 'Our venue dresses up for the holidays: an elegant tree, warm lights and gift parcels. Gala dinner, cocktail party or Christmas cooking challenge — and if you only need the space, we rent it already styled for the festivities.',
      formatsKicker: 'Christmas formats',
      formats: [
        { title: 'Corporate Christmas dinner', desc: 'A dedicated menu by our chefs, served in the venue dressed for the holidays.' },
        { title: 'Cocktail & Wine Party', desc: 'Toasts, cocktail bar and guided tastings to celebrate the year together.' },
        { title: 'Christmas Cooking Challenge', desc: 'Your team at the stoves, between festive recipes and themed challenges.' },
        { title: 'Styled venue hire', desc: 'Tree, lights and decorations already set: you bring the guests, we handle the rest.' },
      ],
      menuTitle: 'Dedicated services and menus',
      menuText: 'Christmas menus designed by our chefs, selected ingredients and full staff: tell us your guest count and budget, we will send you a proposal within 24 hours.',
      menuCta: 'Discover services & menus',
      bannerTitle: 'Book your Christmas Party date',
      bannerText: 'December dates fill up fast: contact us and let\u2019s lock in your evening together.',
      bannerCta: 'Contact us',
    },
    contatti: {
      kicker: 'Contact',
      title: 'Tell us about your event',
      intro: 'Fill in the form: we will get back to you within 24 hours with a tailor-made proposal.',
      infoTitle: 'Where to find us',
      phoneLabel: 'Phone',
      emailLabel: 'Email',
      addressLabel: 'Address',
      address: 'Via Gustavo Modena 28, 20129 Milan',
      form: {
        name: 'Full name',
        email: 'Email',
        phone: 'Phone (optional)',
        eventType: 'Event type',
        types: ['Cooking Team Building', 'Wine / Cocktail Experience', 'Corporate event', 'Promotion event', 'Catering', 'Venue hire', 'Other'],
        guests: 'Number of guests (optional)',
        message: 'Tell us about your event',
        submit: 'Send request',
        sending: 'Sending…',
        success: 'Request sent! We will get back to you within 24 hours.',
        error: 'Something went wrong. Please try again or write to eventi@gustavo28.it',
      },
    },
    footer: {
      tagline: 'One partner, one location, every service.',
      exploreTitle: 'Explore',
      contactTitle: 'Contact',
      partnersTitle: 'Partners',
      rights: '© 2026 Gustavo 28 — Milan',
    },
  },
  es: {
    meta: {
      homeTitle: 'Gustavo 28 — Eventos, Team Building y Catering en Milán',
      homeDesc: 'Team building de cocina, vino y cerveza, eventos de empresa y catering: en nuestra location de 160 m² en Milán, en vuestras oficinas o donde prefiráis. Un único socio, todos los servicios.',
      serviziTitle: 'Servicios — Cocina, Vino, Catering y Eventos | Gustavo 28 Milán',
      serviziDesc: 'Cooking team building, experiencias de vino y cóctel, eventos de empresa, promoción de marcas y catering: descubre la oferta de Gustavo 28 en Milán o en tu sede.',
      tbTitle: 'Team Building en Milán — Cocina, Vino y Cóctel | Gustavo 28',
      tbDesc: 'Paquetes de team building modulables: cooking challenge, wine & cocktail lab, beer experience y food & art. En nuestra location o en tu empresa, también en inglés, español, francés, japonés y chino.',
      locationTitle: 'Location para Press Day y Showroom Temporal en Milán | Gustavo 28',
      locationDesc: 'Location en alquiler exclusivo en Milán: press day, presentaciones de producto, showrooms temporales para el Salone del Mobile y la Fashion Week, cenas privadas con chef y eventos de empresa. Con o sin montaje.',
      locationKeys: 'location para press day Milán, showroom temporal Salone del Mobile, alquiler location exclusiva Milán, location Fashion Week Milán, cenas privadas con chef Milán, alquiler espacio eventos Milán',
      xmasTitle: 'Business Christmas Party en Milán — Location y menús dedicados | Gustavo 28',
      xmasDesc: 'Organiza el Christmas Party de tu empresa en Milán: location ambientada con árbol y decoración, menús dedicados de nuestros chefs, cócteles y cooking challenge navideña. Contáctanos.',
      contattiTitle: 'Contacto — Pide un Presupuesto | Gustavo 28 Milán',
      contattiDesc: 'Contacta con Gustavo 28 para organizar tu evento o team building en Milán o en tu sede: rellena el formulario y recibe una propuesta a medida en 24 horas.',
    },
    nav: { home: 'Inicio', servizi: 'Servicios', tb: 'Team Building', xmas: 'Christmas Party', location: 'La Location', contatti: 'Contacto', cta: 'Pide un presupuesto' },
    home: {
      kicker: 'Milán · Casa Maggioni, 1909',
      heroLines: ['Un único socio,', 'una location,', 'todos los servicios.'],
      heroSub: 'Team building de cocina, vino y cerveza, eventos de empresa, catering y promoción de marcas: en nuestra location, en vuestras oficinas o donde prefiráis. De la idea a la realización, nos ocupamos de todo.',
      ctaPrimary: 'Pide un presupuesto',
      ctaSecondary: 'Descubre la location',
      scroll: 'Desliza',
      marquee: ['Cocina', 'Vino', 'Cóctel', 'Food & Art', 'Catering', 'Team Building', 'Eventos de Empresa', 'Sostenibilidad'],
      chaptersKicker: 'Gustavo 28 en breve',
      chapters: [
        { title: 'Quiénes somos', text: 'Gustavo 28 está especializada en la creación de eventos exclusivos, actividades de team building y eventos de promoción para marcas. Nuestra misión es satisfacer las necesidades de los clientes con servicios eficientes, innovadores y a medida.' },
        { title: 'Estés donde estés', text: 'Realizamos nuestros eventos en nuestra location de Via Gustavo Modena 28, pero también en vuestras oficinas o en cualquier espacio que elijáis. Mismo equipo, misma calidad, mismo cuidado: lo llevamos todo nosotros.' },
        { title: 'La location', text: '160 m² en dos plantas en un palacio señorial de estilo liberty de 1909, también en alquiler exclusivo: cenas privadas con chef, press day y presentaciones de producto, showrooms temporales para la Fashion Week y el Salone del Mobile, eventos corporativos institucionales. Con o sin montaje interior: la cocina profesional es móvil y se puede retirar.', cta: 'Visita la location' },
      ],
      servicesKicker: 'Nuestra oferta',
      servicesTitle: 'Experiencias a medida',
      services: [
        { title: 'Cooking Team Building', desc: 'Retos entre fogones y clases de cocina con chefs profesionales, en nuestra cocina industrial o en vuestra sede.' },
        { title: 'Wine & Cocktail Experience', desc: 'Catas guiadas y mixología, con tutores dedicados y bodegas seleccionadas.' },
        { title: 'Eventos de Empresa y Promoción', desc: 'Reuniones, cenas de gala, lanzamientos de producto y brand activation, de la idea a la realización.' },
        { title: 'Catering & Banqueting', desc: 'Catering de calidad en nuestra location o donde prefieras, con materias primas seleccionadas.' },
      ],
      servicesCta: 'Todos los servicios',
      partnersKicker: 'Partners y proveedores',
      galleryKicker: 'La galería',
      galleryTitle: 'Nuestros eventos',
      partners: ['Gentile since 1950', 'Midora Atelier Gastronomico', 'F.lli Abrigo · Cascina Langairolo', 'Casa Bugatti', 'Alma Design'],
      bannerTitle: '¿Listo para crear tu evento?',
      bannerText: 'Cuéntanos tu idea: te respondemos en 24 horas con una propuesta a medida.',
      bannerCta: 'Hablemos',
    },
    servizi: {
      kicker: 'Los servicios',
      title: 'Una oferta amplia e innovadora',
      intro: 'Combinamos cocina, cócteles, vino, arte, diseño y formación en formatos sostenibles y de bajo impacto. En nuestra location de Milán, en vuestras oficinas o en el espacio que prefiráis: nuestro equipo os alcanza donde estéis.',
      items: [
        { title: 'Alquiler de la Location en Exclusiva', desc: 'Cenas privadas con chef, press day y presentaciones de producto, showrooms temporales para la Fashion Week y el Salone del Mobile, eventos institucionales: 160 m² todo para ti, con o sin montaje — la cocina es móvil y se puede retirar.' },
        { title: 'Cooking Team Building', desc: 'Retos de cocina, clases y formatos creativos guiados por chefs profesionales, en nuestra cocina industrial de acero o equipando vuestra sede.' },
        { title: 'Wine & Beer Experience', desc: 'Catas guiadas y recorridos por el mundo del vino y la cerveza artesanal, con tutores dedicados, también en vuestras oficinas.' },
        { title: 'Cocktail & Food Art', desc: 'Mixología, food design y arte se unen en experiencias inmersivas y espectaculares, en nuestra location o en la vuestra.' },
        { title: 'Eventos de Empresa', desc: 'Reuniones, convenciones, cenas de gala y celebraciones, gestionados de la idea a la realización, en location nuestra o vuestra.' },
        { title: 'Eventos de Promoción', desc: 'Lanzamientos de producto, brand activation y eventos temporales para contar tu marca, donde haga falta.' },
        { title: 'Catering & Banqueting', desc: 'Catering de calidad, en nuestra location o donde prefieras, con materias primas seleccionadas.' },
      ],
      cardCta: 'Solicita este servicio',
      bannerTitle: '¿No encuentras lo que buscas?',
      bannerText: 'Cada evento se hace a medida: cuéntanos tu idea y la construimos juntos.',
      bannerCta: 'Contáctanos',
    },
    tb: {
      kicker: 'Team Building',
      title: 'Paquetes modulables, experiencias inolvidables',
      intro: 'En nuestra location de Via Gustavo Modena 28, en vuestras oficinas o en un espacio elegido por vosotros: cada paquete se adapta a las necesidades de tu equipo.',
      formatsKicker: 'Los formatos',
      formats: [
        { title: 'Cooking Challenge', desc: 'Brigadas entre fogones, cajas misteriosas y veredicto final: la metáfora perfecta del trabajo en equipo.' },
        { title: 'Wine & Cocktail Lab', desc: 'Crea el cóctel perfecto con nuestros bartenders y sommeliers.' },
        { title: 'Beer Experience', desc: 'Descubre la cerveza artesanal: estilos, maridajes y cata guiada.' },
        { title: 'Food & Art', desc: 'Donde la cocina encuentra la creatividad: food design, emplatado y arte.' },
      ],
      langsKicker: 'Multilingüe',
      langsTitle: 'Actividades en idiomas extranjeros',
      cookingLabel: 'Team building de cocina',
      cookingLangs: 'Inglés · Español · Francés · Japonés · Chino',
      wineLabel: 'Team building de cócteles y vino',
      wineLangs: 'Inglés · Español',
      langsNote: 'Sujeto a la disponibilidad de nuestros chefs y tutores dedicados.',
      bannerTitle: 'Construimos tu team building',
      bannerText: 'Dinos objetivos, número de participantes y presupuesto: del resto nos ocupamos nosotros.',
      bannerCta: 'Pide una propuesta',
    },
    location: {
      kicker: 'La Location',
      title: 'Elegante, versátil, tuya',
      intro: 'Via Gustavo Modena 28, Milán. Un palacio señorial en la zona Indipendenza/Risorgimento de 160 m² en dos plantas.',
      floorsKicker: 'Dos plantas, infinitas posibilidades',
      floors: [
        { title: 'Planta 0 — La cocina', text: 'Dos escaparates (oscurecibles) y una cocina profesional equipada con bancos, hornos, placas de inducción y potencia eléctrica adecuada.' },
        { title: 'Planta -1 — El espacio modulable', text: 'Deliberadamente vacío para personalizarlo según las necesidades del cliente, con barra móvil y cava de vino en hierro.' },
      ],
      featuresKicker: 'Por qué elegirla',
      features: [
        { title: 'Elegante y versátil', desc: 'Un palacio señorial liberty de 1909: ladrillo visto, luces cálidas y detalles refinados.' },
        { title: 'Equipamiento técnico incluido', desc: 'Cocina profesional completa y potencia eléctrica adecuada para cada formato.' },
        { title: 'Layout flexible', desc: 'Espacios modulables y personalizables para cada tipo de evento, de la reunión a la cena de gala.' },
        { title: 'También en alquiler', desc: 'La location está disponible para tu evento, con o sin nuestros servicios — y con o sin montaje: la cocina es móvil.' },
      ],
      rentKicker: 'Alquiler en exclusiva',
      rentTitle: 'Un espacio que se adapta a tu evento',
      rentCases: [
        { title: 'Cenas privadas con chef', desc: 'Una cena exclusiva con chef dedicado, en un espacio reservado solo para vosotros.' },
        { title: 'Press day y presentaciones de producto', desc: 'Dos escaparates a la calle y una escenografía elegante para prensa y lanzamientos.' },
        { title: 'Showroom temporal', desc: 'El marco ideal para la Fashion Week y el Salone del Mobile, en el corazón de Milán.' },
        { title: 'Eventos corporativos institucionales', desc: 'Reuniones, celebraciones y momentos oficiales en un palacio liberty de 1909.' },
      ],
      rentNote: 'Con o sin montaje interior: alquila el espacio vacío o ambientado por nosotros. La cocina profesional es móvil y se puede retirar cuando no la necesitas, dejando todo el protagonismo a tu evento.',
      reachKicker: 'Cómo llegar',
      reachTitle: 'Zona Indipendenza / Risorgimento',
      reachText: 'MM Dateo (línea azul, 300 m) o Tricolore. Aparcamiento recomendado: Via Gustavo Modena 10, Milán.',
      address: 'Via Gustavo Modena 28, 20129 Milán',
      bannerTitle: 'Ven a ver la location',
      bannerText: 'Organiza una visita: la mejor manera de imaginar tu evento es vivir el espacio.',
      bannerCta: 'Reserva una visita',
    },
    xmas: {
      kicker: 'Navidad 2026 · Milán',
      title: 'Organiza con nosotros tu Business Christmas Party',
      intro: 'Nuestra location se viste de fiesta: árbol elegante, luces cálidas y regalos. Cena de gala, cocktail party o cooking challenge navideña — y si solo necesitas el espacio, lo alquilamos ya ambientado.',
      formatsKicker: 'Los formatos navideños',
      formats: [
        { title: 'Cena de Navidad de empresa', desc: 'Menú dedicado de nuestros chefs, servido en la location vestida para las fiestas.' },
        { title: 'Cocktail & Wine Party', desc: 'Brindis, barra de cócteles y catas guiadas para celebrar el año juntos.' },
        { title: 'Cooking Challenge navideña', desc: 'El equipo entre fogones, entre recetas navideñas y retos temáticos.' },
        { title: 'Location ambientada en alquiler', desc: 'Árbol, luces y decoración ya listos: tú traes los invitados, del resto nos ocupamos nosotros.' },
      ],
      menuTitle: 'Servicios y menús dedicados',
      menuText: 'Menús navideños diseñados por nuestros chefs, materias primas seleccionadas y staff completo: cuéntanos número de invitados y presupuesto, te enviamos la propuesta en 24 horas.',
      menuCta: 'Descubre servicios y menús',
      bannerTitle: 'Reserva la fecha de tu Christmas Party',
      bannerText: 'Las fechas de diciembre se agotan rápido: contáctanos y bloqueamos juntos la velada.',
      bannerCta: 'Contáctanos',
    },
    contatti: {
      kicker: 'Contacto',
      title: 'Cuéntanos tu evento',
      intro: 'Rellena el formulario: te contactaremos en 24 horas con una propuesta a medida.',
      infoTitle: 'Dónde estamos y cómo contactarnos',
      phoneLabel: 'Teléfono',
      emailLabel: 'Email',
      addressLabel: 'Dirección',
      address: 'Via Gustavo Modena 28, 20129 Milán',
      form: {
        name: 'Nombre y apellido',
        email: 'Email',
        phone: 'Teléfono (opcional)',
        eventType: 'Tipo de evento',
        types: ['Cooking Team Building', 'Wine / Cocktail Experience', 'Evento de empresa', 'Evento de promoción', 'Catering', 'Alquiler de la location', 'Otro'],
        guests: 'Número de invitados (opcional)',
        message: 'Cuéntanos tu evento',
        submit: 'Enviar solicitud',
        sending: 'Enviando…',
        success: '¡Solicitud enviada! Te contactaremos en 24 horas.',
        error: 'Algo salió mal. Inténtalo de nuevo o escribe a eventi@gustavo28.it',
      },
    },
    footer: {
      tagline: 'Un único socio, una location, todos los servicios.',
      exploreTitle: 'Explorar',
      contactTitle: 'Contacto',
      partnersTitle: 'Partners',
      rights: '© 2026 Gustavo 28 — Milán',
    },
  },
  de: {
    meta: {
      homeTitle: 'Gustavo 28 — Events, Teambuilding & Catering in Mailand',
      homeDesc: 'Cooking-, Wein- & Bier-Teambuilding, Firmenevents und Catering: in unserer 160 m² Location in Mailand, in Ihren Büros oder wo immer Sie möchten. Ein Partner, alle Services.',
      serviziTitle: 'Services — Cooking, Wein, Catering & Events | Gustavo 28 Mailand',
      serviziDesc: 'Cooking-Teambuilding, Wein- & Cocktail-Erlebnisse, Firmenevents, Markenpromotion und Catering: entdecken Sie das Angebot von Gustavo 28 in Mailand oder in Ihren Räumen.',
      tbTitle: 'Teambuilding in Mailand — Cooking, Wein & Cocktail | Gustavo 28',
      tbDesc: 'Modulare Teambuilding-Pakete: Cooking Challenge, Wine & Cocktail Lab, Beer Experience und Food & Art. In unserer Location oder in Ihrem Unternehmen, auch auf Englisch, Spanisch, Französisch, Japanisch und Chinesisch.',
      locationTitle: 'Location für Press Days & temporäre Showrooms in Mailand | Gustavo 28',
      locationDesc: 'Location exklusiv zu mieten in Mailand: Press Days, Produktpräsentationen, temporäre Showrooms für Salone del Mobile und Fashion Week, private Dinner mit Koch und Firmenevents. Mit oder ohne Ausstattung.',
      locationKeys: 'Location für Press Days Mailand, temporärer Showroom Salone del Mobile, Location exklusiv mieten Mailand, Fashion Week Location Mailand, privates Dinner mit Koch Mailand, Eventlocation Mailand mieten',
      xmasTitle: 'Business Christmas Party in Mailand — Location & eigene Menüs | Gustavo 28',
      xmasDesc: 'Organisieren Sie Ihre Firmen-Weihnachtsfeier in Mailand: festlich geschmückte Location mit Baum, eigene Menüs unserer Köche, Cocktails und weihnachtliche Cooking Challenge. Kontaktieren Sie uns.',
      contattiTitle: 'Kontakt — Angebot anfordern | Gustavo 28 Mailand',
      contattiDesc: 'Kontaktieren Sie Gustavo 28 für Ihr Event oder Teambuilding in Mailand oder in Ihren Räumen: Formular ausfüllen und innerhalb von 24 Stunden ein maßgeschneidertes Angebot erhalten.',
    },
    nav: { home: 'Start', servizi: 'Services', tb: 'Teambuilding', xmas: 'Christmas Party', location: 'Die Location', contatti: 'Kontakt', cta: 'Angebot anfordern' },
    home: {
      kicker: 'Mailand · Casa Maggioni, 1909',
      heroLines: ['Ein Partner,', 'eine Location,', 'alle Services.'],
      heroSub: 'Cooking-, Wein- & Bier-Teambuilding, Firmenevents, Catering und Markenpromotion: in unserer Location, in Ihren Büros oder wo immer Sie möchten. Von der Idee bis zur Umsetzung kümmern wir uns um alles.',
      ctaPrimary: 'Angebot anfordern',
      ctaSecondary: 'Location entdecken',
      scroll: 'Scrollen',
      marquee: ['Cooking', 'Wein', 'Cocktail', 'Food & Art', 'Catering', 'Teambuilding', 'Firmenevents', 'Nachhaltigkeit'],
      chaptersKicker: 'Gustavo 28 in Kürze',
      chapters: [
        { title: 'Wer wir sind', text: 'Gustavo 28 ist auf exklusive Events, Teambuilding-Aktivitäten und Markenpromotion spezialisiert. Unsere Mission: effiziente, innovative und maßgeschneiderte Services für unsere Kunden.' },
        { title: 'Wo immer Sie sind', text: 'Wir realisieren unsere Events in unserer Location in der Via Gustavo Modena 28, aber auch in Ihren Büros oder in einem Raum Ihrer Wahl. Gleiches Team, gleiche Qualität, gleiche Sorgfalt: Wir bringen alles mit.' },
        { title: 'Die Location', text: '160 m² auf zwei Etagen in einem herrschaftlichen Jugendstilpalast von 1909, auch exklusiv zu mieten: private Dinner mit Koch, Press Days und Produktpräsentationen, temporäre Showrooms für Fashion Week und Salone del Mobile, institutionelle Firmenevents. Mit oder ohne Innenausstattung: Die Profiküche ist mobil und kann entfernt werden.', cta: 'Location besichtigen' },
      ],
      servicesKicker: 'Unser Angebot',
      servicesTitle: 'Maßgeschneiderte Erlebnisse',
      services: [
        { title: 'Cooking Teambuilding', desc: 'Koch-Challenges und Kurse mit Profiköchen, in unserer industriellen Küche oder in Ihren Räumen.' },
        { title: 'Wine & Cocktail Experience', desc: 'Geführte Verkostungen und Mixology, mit dedizierten Tutoren und ausgewählten Weingütern.' },
        { title: 'Firmen- & Promotion-Events', desc: 'Meetings, Gala-Dinner, Produkteinführungen und Brand Activations — von der Idee bis zur Umsetzung.' },
        { title: 'Catering & Banqueting', desc: 'Hochwertiges Catering in unserer Location oder an Ihrem Wunschort, mit ausgewählten Zutaten.' },
      ],
      servicesCta: 'Alle Services',
      partnersKicker: 'Partner & Lieferanten',
      galleryKicker: 'Die Galerie',
      galleryTitle: 'Unsere Events',
      partners: ['Gentile since 1950', 'Midora Atelier Gastronomico', 'F.lli Abrigo · Cascina Langairolo', 'Casa Bugatti', 'Alma Design'],
      bannerTitle: 'Bereit für Ihr Event?',
      bannerText: 'Erzählen Sie uns von Ihrer Idee: Wir antworten innerhalb von 24 Stunden mit einem maßgeschneiderten Angebot.',
      bannerCta: 'Sprechen wir darüber',
    },
    servizi: {
      kicker: 'Unsere Services',
      title: 'Ein breites, innovatives Angebot',
      intro: 'Wir verbinden Küche, Cocktails, Wein, Kunst, Design und Training in nachhaltigen, ressourcenschonenden Formaten. In unserer Location in Mailand, in Ihren Büros oder an einem Ort Ihrer Wahl: Unser Team erreicht Sie überall.',
      items: [
        { title: 'Exklusive Location-Miete', desc: 'Private Dinner mit Koch, Press Days und Produktpräsentationen, temporäre Showrooms für Fashion Week und Salone del Mobile, institutionelle Events: 160 m² ganz für Sie, mit oder ohne Ausstattung — die Küche ist mobil und kann entfernt werden.' },
        { title: 'Cooking Teambuilding', desc: 'Koch-Challenges, Kurse und kreative Formate mit Profiköchen, in unserer industriellen Stahlküche oder mit Ausstattung Ihrer Räume.' },
        { title: 'Wine & Beer Experience', desc: 'Geführte Verkostungen und Entdeckungsreisen durch Wein und Craft Beer, mit dedizierten Tutoren, auch in Ihren Büros.' },
        { title: 'Cocktail & Food Art', desc: 'Mixology, Food Design und Kunst verschmelzen zu immersiven, spektakulären Erlebnissen, in unserer Location oder bei Ihnen.' },
        { title: 'Firmenevents', desc: 'Meetings, Tagungen, Gala-Dinner und Feiern — von der Idee bis zur Umsetzung, in unserer oder Ihrer Location.' },
        { title: 'Promotion-Events', desc: 'Produktlaunches, Brand Activations und Pop-up-Events, die Ihre Marke erzählen — überall dort, wo es zählt.' },
        { title: 'Catering & Banqueting', desc: 'Hochwertiges Catering in unserer Location oder an Ihrem Wunschort, mit ausgewählten Zutaten.' },
      ],
      cardCta: 'Diesen Service anfragen',
      bannerTitle: 'Nicht das Richtige dabei?',
      bannerText: 'Jedes Event wird maßgeschneidert: Erzählen Sie uns Ihre Idee und wir bauen sie gemeinsam.',
      bannerCta: 'Kontakt aufnehmen',
    },
    tb: {
      kicker: 'Teambuilding',
      title: 'Modulare Pakete, unvergessliche Erlebnisse',
      intro: 'In unserer Location in der Via Gustavo Modena 28, in Ihren Büros oder in einer Location Ihrer Wahl: Jedes Paket wird auf die Bedürfnisse Ihres Teams zugeschnitten.',
      formatsKicker: 'Die Formate',
      formats: [
        { title: 'Cooking Challenge', desc: 'Teams am Herd, Mystery-Boxen und ein finales Urteil: die perfekte Metapher für Teamarbeit.' },
        { title: 'Wine & Cocktail Lab', desc: 'Kreieren Sie den perfekten Drink mit unseren Barkeepern und Sommeliers.' },
        { title: 'Beer Experience', desc: 'Craft Beer entdecken: Stile, Pairings und geführte Verkostung.' },
        { title: 'Food & Art', desc: 'Wo Küche auf Kreativität trifft: Food Design, Plating und Kunst.' },
      ],
      langsKicker: 'Mehrsprachig',
      langsTitle: 'Aktivitäten in Fremdsprachen',
      cookingLabel: 'Cooking-Teambuilding',
      cookingLangs: 'Englisch · Spanisch · Französisch · Japanisch · Chinesisch',
      wineLabel: 'Cocktail- & Wein-Teambuilding',
      wineLangs: 'Englisch · Spanisch',
      langsNote: 'Vorbehaltlich der Verfügbarkeit unserer Köche und Tutoren.',
      bannerTitle: 'Wir bauen Ihr Teambuilding',
      bannerText: 'Nennen Sie uns Ziele, Gruppengröße und Budget: um den Rest kümmern wir uns.',
      bannerCta: 'Angebot anfordern',
    },
    location: {
      kicker: 'Die Location',
      title: 'Elegant, vielseitig, Ihre',
      intro: 'Via Gustavo Modena 28, Mailand. Ein herrschaftlicher Palast im Viertel Indipendenza/Risorgimento mit 160 m² auf zwei Etagen.',
      floorsKicker: 'Zwei Etagen, endlose Möglichkeiten',
      floors: [
        { title: 'Erdgeschoss — Die Küche', text: 'Zwei Schaufenster (verdunkelbar) und eine Profiküche mit Arbeitsstationen, Öfen, Induktionskochfeldern und ausreichender Leistung.' },
        { title: 'Untergeschoss — Der flexible Raum', text: 'Bewusst leer gehalten, um nach Ihren Wünschen gestaltet zu werden — mit mobiler Theke und eisernem Weinkeller.' },
      ],
      featuresKicker: 'Warum diese Location',
      features: [
        { title: 'Elegant & vielseitig', desc: 'Ein herrschaftlicher Jugendstilpalast von 1909: Sichtziegel, warmes Licht und edle Details.' },
        { title: 'Technische Ausstattung inklusive', desc: 'Komplett ausgestattete Profiküche und ausreichende Stromleistung für jedes Format.' },
        { title: 'Flexibles Layout', desc: 'Modulare, anpassbare Räume für jede Art von Event — vom Meeting bis zum Gala-Dinner.' },
        { title: 'Auch zur Miete', desc: 'Die Location kann für Ihr Event gemietet werden — mit oder ohne unsere Services, mit oder ohne Ausstattung: Die Küche ist mobil.' },
      ],
      rentKicker: 'Exklusive Miete',
      rentTitle: 'Ein Raum, der sich Ihrem Event anpasst',
      rentCases: [
        { title: 'Private Dinner mit Koch', desc: 'Ein exklusives Dinner mit persönlichem Koch, in einem Raum ganz für Sie.' },
        { title: 'Press Days & Produktpräsentationen', desc: 'Zwei Schaufenster zur Straße und eine elegante Kulisse für Presse und Launches.' },
        { title: 'Temporärer Showroom', desc: 'Der ideale Rahmen für Fashion Week und Salone del Mobile, im Herzen Mailands.' },
        { title: 'Institutionelle Firmenevents', desc: 'Meetings, Feiern und offizielle Anlässe in einem Jugendstilpalast von 1909.' },
      ],
      rentNote: 'Mit oder ohne Innenausstattung: Mieten Sie den Raum leer oder von uns gestaltet. Die Profiküche ist mobil und kann bei Bedarf entfernt werden — so gehört die Bühne ganz Ihrem Event.',
      reachKicker: 'Anfahrt',
      reachTitle: 'Viertel Indipendenza / Risorgimento',
      reachText: 'U-Bahn Dateo (blaue Linie, 300 m) oder Tricolore. Empfohlener Parkplatz: Via Gustavo Modena 10, Mailand.',
      address: 'Via Gustavo Modena 28, 20129 Mailand',
      bannerTitle: 'Besichtigen Sie die Location',
      bannerText: 'Vereinbaren Sie einen Besuch: Der beste Weg, Ihr Event zu planen, ist den Raum zu erleben.',
      bannerCta: 'Besuch vereinbaren',
    },
    xmas: {
      kicker: 'Weihnachten 2026 · Mailand',
      title: 'Organisieren Sie Ihre Business Christmas Party mit uns',
      intro: 'Unsere Location kleidet sich festlich: edler Baum, warmes Licht und Geschenkpakete. Gala-Dinner, Cocktailparty oder weihnachtliche Cooking Challenge — und wenn Sie nur den Raum brauchen, vermieten wir ihn bereits festlich dekoriert.',
      formatsKicker: 'Die Weihnachtsformate',
      formats: [
        { title: 'Firmen-Weihnachtsessen', desc: 'Ein eigenes Menü unserer Köche, serviert in der festlich geschmückten Location.' },
        { title: 'Cocktail- & Weinparty', desc: 'Empfang, Cocktailbar und geführte Verkostungen, um das Jahr gemeinsam zu feiern.' },
        { title: 'Weihnachts-Cooking-Challenge', desc: 'Ihr Team am Herd — zwischen Festtagsrezepten und thematischen Challenges.' },
        { title: 'Dekorierte Location zur Miete', desc: 'Baum, Lichter und Dekoration bereits aufgebaut: Sie bringen die Gäste, wir kümmern uns um den Rest.' },
      ],
      menuTitle: 'Services und Menüs nach Maß',
      menuText: 'Weihnachtsmenüs von unseren Köchen, ausgewählte Zutaten und komplettes Personal: Nennen Sie uns Gästezahl und Budget — Sie erhalten Ihr Angebot innerhalb von 24 Stunden.',
      menuCta: 'Services & Menüs entdecken',
      bannerTitle: 'Sichern Sie sich Ihren Termin',
      bannerText: 'Die Dezember-Termine sind schnell vergeben: Kontaktieren Sie uns und wir reservieren Ihren Abend.',
      bannerCta: 'Kontaktieren Sie uns',
    },
    contatti: {
      kicker: 'Kontakt',
      title: 'Erzählen Sie uns von Ihrem Event',
      intro: 'Füllen Sie das Formular aus: Wir melden uns innerhalb von 24 Stunden mit einem maßgeschneiderten Angebot.',
      infoTitle: 'Kontakt & Anfahrt',
      phoneLabel: 'Telefon',
      emailLabel: 'E-Mail',
      addressLabel: 'Adresse',
      address: 'Via Gustavo Modena 28, 20129 Mailand',
      form: {
        name: 'Vor- und Nachname',
        email: 'E-Mail',
        phone: 'Telefon (optional)',
        eventType: 'Art des Events',
        types: ['Cooking Teambuilding', 'Wine / Cocktail Experience', 'Firmenevent', 'Promotion-Event', 'Catering', 'Location-Miete', 'Sonstiges'],
        guests: 'Anzahl der Gäste (optional)',
        message: 'Erzählen Sie uns von Ihrem Event',
        submit: 'Anfrage senden',
        sending: 'Wird gesendet…',
        success: 'Anfrage gesendet! Wir melden uns innerhalb von 24 Stunden.',
        error: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder schreiben Sie an eventi@gustavo28.it',
      },
    },
    footer: {
      tagline: 'Ein Partner, eine Location, alle Services.',
      exploreTitle: 'Entdecken',
      contactTitle: 'Kontakt',
      partnersTitle: 'Partner',
      rights: '© 2026 Gustavo 28 — Mailand',
    },
  },
};
